import Vue from 'vue'
import {
    Input,
    Checkbox,
    Button,
    Tree
} from 'element-ui';

// import "ant-design-vue/dist/antd.less"; // 引入官方提供的 less 样式入口文件

Vue.use(Input)
Vue.use(Checkbox)
Vue.use(Button)
Vue.use(Tree)

